import { lazy, Suspense } from "react";
import { createRoot } from "react-dom/client";
import { LicenseInfo } from "@mui/x-license-pro";

const container = document.querySelector("#root");
if (container == null) {
  console.error("Unable to find a root element.");
} else {
  console.debug("Injecting React into page.");

  // This is considered public information by MUI and doesn't need to be treated as any kind of secret.
  LicenseInfo.setLicenseKey(
    "ff65873dad930370914b96a67faa7c9dTz0xMDM5MzMsRT0xNzY1MzM4MDk0MDAwLFM9cHJvLExNPXN1YnNjcmlwdGlvbixQVj1RMy0yMDI0LEtWPTI=",
  );

  try {
    const Application = lazy(async () => import("./Application.js"));
    const loadTime = new Date();

    const root = createRoot(container);
    root.render(
      <Suspense
        fallback={
          <div className="simple-message">
            <p>Loading...</p>
          </div>
        }
      >
        <Application loadTime={loadTime} />
      </Suspense>,
    );
  } catch (e: unknown) {
    container.innerHTML = `<div class="simple-message"><p>Unable to load application.</p><pre>${e}</pre></div>`;
  }
}
